/**
 * Converts ImageData to a Base64-encoded string.
 *
 * @param imageData - The ImageData to be converted.
 * @param format - Optional format for the output (default: 'image/png').
 * @returns A Base64 string representation of the image.
 */

function imageDataToBase64(
  imageData: ImageData,
  format: string = "image/png"
): string {
  // Create an off-screen canvas to draw the ImageData
  const canvas = document.createElement("canvas")
  canvas.width = imageData.width
  canvas.height = imageData.height

  const ctx = canvas.getContext("2d")
  if (!ctx) {
    throw new Error("Failed to get canvas 2D context")
  }

  // Put the ImageData on the canvas
  ctx.putImageData(imageData, 0, 0)

  // Get the Base64-encoded image data URL
  return canvas.toDataURL(format) // Defaults to 'image/png'
}

export default imageDataToBase64
